export default __webpack_public_path__ + "static/media/services.0fb78869.svg";